export default "__VITE_ASSET__76cfJ0F0__"